import React, { Component } from "react";
import axios from "axios";
import UploadPhotoGalleryById from "./UploadProducts";
import domain from "../../../../domain";

import { Row, Col, Card, CardBody } from "mdbreact";
import { Badge } from "mdbreact";

const moment = require("moment-timezone");
// function indexN(cell, row, enumObject, index) {
//     return (<div>{index+1}</div>)
// }
function dateFormatter(cell) {
  return moment(cell).tz("Asia/Kolkata").format("DD/MM/YYYY");
}
// function timeFormatter(cell) {
//   return moment(cell,"h:mm a").format("HH:mm a")

//  }

class AddPhotoGalleryById extends Component {
  constructor() {
    super();
    this.state = {
      courses: null,
    };
  }

  componentDidMount() {
    this.getCourse();
  }

  async getCourse() {
    let result = await axios.get(`${domain.DBServer}/fetch-course`);
    this.setState({
      courses: result.data,
    });
  }

  render() {
    let courses;
    console.log(this.state.courses);
    if (this.state.courses != null) {
      courses = this.state.courses.map((course, key) => {
        return (
          <tr key={key}>
            {/* {console.log(course.course_id)} */}
            <th scope="row" style={{ textAlign: "right" }}>
              {key + 1}
            </th>
            <td>{course.title}</td>
            <td>{dateFormatter(course.start_date)}</td>
            <td>{dateFormatter(course.end_date)}</td>

            <td>
              {course.photo_gallery ? (
                <div>
                  <Badge>Photo Gallery available</Badge>
                  <UploadPhotoGalleryById course={course} />
                </div>
              ) : (
                <div>
                  <UploadPhotoGalleryById course={course} />
                </div>
              )}
            </td>
          </tr>
        );
      });
    }

    return (
      <div>
        <Row>
          <Col md="12">
            <Card>
              <CardBody>
                <h4 style={{ textAlign: "center", color: "blue" }}>
                  List of Courses
                </h4>
                <table
                  className="table table-striped table-bordered table-responsive-md"
                  cellSpacing="0"
                  width="100%"
                >
                  <thead
                    style={{ textAlign: "center", backgroundColor: "#33b5e5" }}
                  >
                    <tr>
                      <th scope="col" width="20">
                        S. No.{" "}
                      </th>
                      <th scope="col" width="50">
                        Couse Name
                      </th>

                      <th scope="col" width="100">
                        Start Date{" "}
                      </th>
                      <th scope="col" width="50">
                        End Date
                      </th>

                      <th scope="col" width="50">
                        Upload Photo Gallery
                      </th>
                    </tr>
                  </thead>
                  <tbody>{courses}</tbody>
                </table>

                <div></div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

export default AddPhotoGalleryById;
